import { fetchPreferencesFromSpoonguru } from "@/services/spoonguru";
import { DEFAULT_RECIPE_NUMBER } from "@/utils/constant";
import {
  useAppDispatch,
  useAppSelector,
  useEffect,
} from "@/utils/hooks/reactUseCustomHooks";
import { setPagecount } from "@/utils/redux/common/pagination";
import { getAemData } from "@/utils/redux/recipes/aemContentSlice/actions";
import { getfetchFavouritesRecipes } from "@/utils/redux/recipes/recipeSlice/actions";
import { RootState } from "@/utils/redux/store";
import { useSearchParams } from "next/navigation";
import { Dispatch } from "redux";
import { useGigyaToken } from "./commonRecipeFunctions/getGigyaToken";

const usePageHandler = () => {
  const dispatch: Dispatch<any> = useAppDispatch();
  const { getAccountInfo } = useGigyaToken();
  const { uid: Uid } = useAppSelector((state: RootState) => state.gigyaslice);
  const searchParams = useSearchParams();
  const itemsPerPageQuery: any = searchParams.get("itemsPerPage");
  const perPage: number = parseInt(itemsPerPageQuery);
  useEffect(() => {
    const pageValue: number = perPage > 0 ? perPage : DEFAULT_RECIPE_NUMBER;
    dispatch(setPagecount(pageValue));
    dispatch(getAemData());
    if (Uid) {
      const fetchFav = async () => {
        const { idToken: token } = await getAccountInfo();
        dispatch(getfetchFavouritesRecipes({ token }));
        void fetchPreferencesFromSpoonguru(`/preferences/${Uid}`);
      };

      void fetchFav();
    }
  }, [Uid, itemsPerPageQuery]);
};

export default usePageHandler;
